import { FlowMessengerActionSubflowReturnPayload } from 'lib-shared-types-api';

import { flowNodeColor } from 'fable/flowEditor';
import { TextBreak } from 'fable/flowEditor/components/flowManager/canvas/node/textBreak';
import { MessengerExtraData } from 'fable/flowEditor/components/flowManager/canvas/types/extraData';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import type {
  GenericNodeAttributes,
  GenericNodeProps,
} from 'flow-builder/types/node';

import { SubflowReturnModal } from '../modal/subflowReturnModal';

type SubflowReturnNodeAttributes =
  GenericNodeAttributes<FlowMessengerActionSubflowReturnPayload>;

type SubflowReturnNodeProps = GenericNodeProps<
  FlowMessengerActionSubflowReturnPayload,
  MessengerExtraData
>;

const translatePayloadToConnections: SubflowReturnNodeAttributes['translatePayload'] =
  // This is a terminal node, so we don't need to update anything
  (_node) => {
    return [];
  };

const onUpdateConnection: SubflowReturnNodeAttributes['updateConnection'] = (
  node,
  _connectedNode,
  _connectionId,
) => {
  // This is a terminal node, so we don't need to update anything
  return node;
};

export function SubflowReturnNode({
  node,
}: SubflowReturnNodeProps): JSX.Element {
  const { payload } = node;

  return (
    <TextContent>
      <TextBreak>
        <Text weight="semibold" text={payload.label} />
      </TextBreak>
    </TextContent>
  );
}

export const SubflowReturnNodeAttributes: SubflowReturnNodeAttributes = {
  iconName: 'plug',
  label: 'Back to main flow',
  color: hexStringToNumber(flowNodeColor.green),
  translatePayload: translatePayloadToConnections,
  updateConnection: onUpdateConnection,
  NodeContent: SubflowReturnNode,
  ActionModal: SubflowReturnModal,
};
